var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7664_194867",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 9.9C19.2913 9.9 22 12.6087 22 15.95C22 19.2913 19.2913 22 15.95 22C12.6087 22 9.9 19.2913 9.9 15.95C9.9 12.6087 12.6087 9.9 15.95 9.9ZM16.225 0C18.1994 0 19.8 1.60058 19.8 3.575L19.8013 9.92485C19.2916 9.59832 18.7376 9.33472 18.1505 9.145L18.15 6.05H1.65V16.225C1.65 17.2881 2.51185 18.15 3.575 18.15L9.145 18.1505C9.33472 18.7376 9.59833 19.2916 9.92485 19.8013L3.575 19.8C1.60058 19.8 0 18.1994 0 16.225V3.575C0 1.60058 1.60058 0 3.575 0H16.225ZM15.95 12.1L15.8511 12.1089C15.6266 12.1496 15.4496 12.3266 15.4089 12.5511L15.4 12.65V15.4H12.65L12.5511 15.4089C12.3266 15.4496 12.1496 15.6266 12.1089 15.8511L12.1 15.95L12.1089 16.0489C12.1496 16.2734 12.3266 16.4504 12.5511 16.4911L12.65 16.5H15.4V19.25L15.4089 19.3489C15.4496 19.5734 15.6266 19.7504 15.8511 19.7911L15.95 19.8L16.0489 19.7911C16.2734 19.7504 16.4504 19.5734 16.4911 19.3489L16.5 19.25V16.5H19.25L19.3489 16.4911C19.5734 16.4504 19.7504 16.2734 19.7911 16.0489L19.8 15.95L19.7911 15.8511C19.7504 15.6266 19.5734 15.4496 19.3489 15.4089L19.25 15.4H16.5V12.65L16.4911 12.5511C16.4504 12.3266 16.2734 12.1496 16.0489 12.1089L15.95 12.1ZM16.225 1.65H3.575C2.51185 1.65 1.65 2.51185 1.65 3.575V4.4H18.15V3.575C18.15 2.51185 17.2881 1.65 16.225 1.65Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7664_194867)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.328125,
    width: 21.8423,
    height: 22,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b9b441a8f4976e75a2de74f4472ef3f7.svg";
export { ForwardRef as ReactComponent };